import QueryBuilder from "../../QueryBuilder"

export default class BlogFeaturedArticleRepository {
    static contentName = "resource_blogResource"
    constructor(protected key: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .rawQuery(
                `*[_id == '${BlogFeaturedArticleRepository.contentName}'][0] { blogs[blogCategoryOption._ref == '${this.key}'] }`,
            )
            .process()

        return results.getResultInfo()
    }
}
